//package/index.js
import PTable from "@/package-admin/p-table/index.js";
import PInput from "@/package-admin/p-input/index.js";
import PTag from "@/package-admin/p-tag/index.js";
import PTooltip from "@/package-admin/p-tooltip/index.js";
import PScrollbar from "@/package-admin/p-scrollbar/index.js";
import PSelect from "@/package-admin/p-select";
import POption from "@/package-admin/p-option";
import POptionGroup from "@/package-admin/p-option-group";
import PSelectDropdown from "@/package-admin/p-select/src/select-dropdown.vue";
import PTableColumn from "@/package-admin/p-table/Table-column/index";
import PTestButton from "@/package-admin/p-test-button/index.vue";
import PCascader from "@/package-admin/p-cascader/index.js";
import PCascaderPanel from "@/package-admin/p-cascader-panel/index.js";
import PCheckbox from "@/package-admin/p-checkbox/index.js";
import PRadio from "@/package-admin/p-radio/index.js";
import  PDatePicker  from "@/package-admin/p-dateTimePicker/index.js";
import  PTimePicker  from "@/package-admin/p-dateTimePicker/index.js";
// 导入语言包
import { use, t, i18n } from '../locale';
import zhCN from '../locale/lang/zh-CN';
import en from '../locale/lang/en';

import '@/theme-chalk/src/index.scss'

// 所有组件
const components = [
    PTable,
    PInput,
    PTag,
    PTooltip,
    PScrollbar,
    PSelect,
    POption,
    POptionGroup,
    PSelectDropdown,
    PTableColumn,
    PTestButton,
    PCascader,
    PCascaderPanel,
    PCheckbox,
    PRadio,
    PDatePicker,
    PTimePicker
];

// install 方法
const install = function (Vue) {
    components.forEach((com) => {
        Vue.component(com.name, com);
    });
};

// 支持按需引入
export { PTable, PInput, PTag, PTooltip, PScrollbar, PSelect, POption, POptionGroup, PSelectDropdown, PTableColumn, PTestButton, PCascader, PCascaderPanel, PCheckbox, PRadio, PDatePicker, PTimePicker };

// 导出语言包相关功能
export { use, t, i18n, zhCN, en };

// 支持全局引入
export default install;
